import gql from 'graphql-tag';

const GET_LOADER = gql`
{
   loader @client {
        show
    }
  }
`;

const defaults = {
  Loader: {
    __typename: 'loader',
    loader: { show: false },
  },
};

export { GET_LOADER, defaults };
